import * as MDICONS from '@material-ui/icons';
import React from 'react'
const initState = {
    // Please do not change the values of variable...
    tag: '0',
    elevation: '1',

    color: {
        '0': 'rgba(235, 116, 52,0.15)',
        '1': 'rgba(174, 52, 235,0.15)',
    },

    textColor: {
        '0': 'rgba(235, 116, 52,1.0)',
        '1': 'rgba(174, 52, 235,1.0)',
    },

    text: {
        '0': 'tag',
        '1': 'elevation',
    },

    icon: {
        '0': <MDICONS.WarningSharp />,
        '1': <MDICONS.MapSharp />,
    },
}


const markerReducer = (state = initState, action) => {

    return state;
}

export default markerReducer;